import { useMutation } from "@tanstack/react-query";

import { apiPaths } from "@/config/paths";
import type { MutationConfig } from "@/lib/react-query";
import { authApi } from "@/lib/api-client";
import { AxiosResponse } from "axios";

type LoginInput = {
  email: string;
  password: string;
  recaptchaToken?: string;
};

type LoginResponse = {
  email?: string;
  phone?: string;
  redirect?: string;
};

// Shape of the 401/429 error body returned by the login route for AAC-002.
export type LoginErrorData = {
  error?: string;
  captchaRequired?: boolean;
  lockout?: boolean;
  retryAfter?: number;
};

const login = ({ data }: { data: LoginInput }): Promise<AxiosResponse<LoginResponse>> => {
  return authApi.post<LoginInput, AxiosResponse<LoginResponse>>(apiPaths.auth.login.getPath(), data);
};

type UseLoginOptions = {
  mutationConfig?: MutationConfig<typeof login>;
};

export const useLogin = ({ mutationConfig }: UseLoginOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: login,
  });
};
